module.exports = __webpack_public_path__ + "h5/img/logo444.cec82dd1.jpg";